import * as d3 from 'd3';

const React = require('react');
const AjaxFunctions = require('./../ajaxFunctions');
const MultiLineTextField = require('./commonControls.jsx').MultiLineTextField;

export class NoteCardCreation extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         noteCardText: '',
      }
   }

   createNoteCard(){
      AjaxFunctions.createNoteCard(this.state.noteCardText, this.props.idPortfolio).then(() => {
         this.setState({noteCardText: ''});
         if(this.props.onNoteCardCreation)
            this.props.onNoteCardCreation();
      });
   }

   render() {
      return (
         <div id='portfolioNoteCardCreation'>
            <MultiLineTextField
               idInput='portfolioNoteCardCreationInput'
               data={this.state.noteCardText}
               isEditing={true}
               onChange= {(event) => this.setState({noteCardText: event.target.value})}
               dataField= ''
               checkForValidationErrors={false}
               placeholder={"Enter text for a new note"}
               maxLength='10000'
            />
            <button id='btnCreateNote' className='btn btn-primary btn-sm' onClick={() => this.createNoteCard()}>
               Add Note
            </button>
         </div>
      );
   }
};